<template>
  <div class="alice-stats">
    <div v-for="(tile, i) in tiles" :key="tile.label" class="alice-stats__tile">
      <div class="alice-stats__row">
        <span class="alice-stats__swatch" :style="{ background: tile.color }" />
        <span class="alice-stats__value">{{ tile.value }}</span>
      </div>
      <div class="alice-stats__label">{{ tile.label }}</div>
      <div class="alice-stats__sub">{{ tile.sub }}</div>
      <span
        v-if="i < tiles.length - 1"
        class="alice-stats__divider"
        aria-hidden="true"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "AliceStatsStrip",
  props: {
    projects: { type: Array, required: true },
  },
  computed: {
    done() {
      return this.projects.filter((p) => p.status === "done").length;
    },
    inProgress() {
      return this.projects.filter((p) => p.status === "in_progress").length;
    },
    drafts() {
      return this.projects.filter((p) => p.status === "draft").length;
    },
    totalN() {
      return this.projects.reduce(
        (s, p) => s + (typeof p.n === "number" ? p.n : 0),
        0
      );
    },
    tiles() {
      return [
        {
          label: "Total projects",
          value: this.projects.length,
          sub: "this year",
          color: "var(--vp-black)",
        },
        {
          label: "Done",
          value: this.done,
          sub: "shipped",
          color: "var(--vp-turquoise-100)",
        },
        {
          label: "In progress",
          value: this.inProgress,
          sub: "active research",
          color: "var(--vp-geel-100)",
        },
        {
          label: "Drafts",
          value: this.drafts,
          sub: "not yet started",
          color: "var(--vp-grijs-60)",
        },
        {
          label: "Participants",
          value: this.totalN.toLocaleString("en-GB"),
          sub: "across all studies",
          color: "var(--vp-rood-100)",
        },
      ];
    },
  },
};
</script>

<style scoped>
.alice-stats {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  border-top: 1px solid var(--border-hairline);
  border-bottom: 1px solid var(--border-hairline);
  background: var(--vp-white);
}
.alice-stats__tile {
  position: relative;
  padding: 20px 24px;
}
.alice-stats__divider {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 1px;
  background: var(--border-hairline);
}
.alice-stats__row {
  display: flex;
  align-items: baseline;
  gap: 10px;
}
.alice-stats__swatch {
  width: 8px;
  height: 8px;
  align-self: center;
  flex-shrink: 0;
}
.alice-stats__value {
  font-family: var(--font-display);
  font-size: 36px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1;
  color: var(--vp-black);
}
.alice-stats__label {
  margin-top: 8px;
  font-family: var(--font-ui);
  font-size: 13px;
  font-weight: 700;
  color: var(--vp-black);
}
.alice-stats__sub {
  font-family: var(--font-ui);
  font-size: 12px;
  color: var(--fg-3);
}

@media (max-width: 1279px) {
  .alice-stats {
    grid-template-columns: 1fr 1fr;
  }
  .alice-stats__divider {
    display: none;
  }
  .alice-stats__tile {
    display: flex;
    align-items: baseline;
    gap: 8px;
    padding: 12px 16px;
    border-bottom: 1px solid var(--border-hairline);
    border-right: 1px solid var(--border-hairline);
  }
  .alice-stats__tile:nth-child(2n) {
    border-right: none;
  }
  .alice-stats__tile:last-child {
    border-bottom: none;
  }
  .alice-stats__value {
    font-size: 22px;
  }
  .alice-stats__label {
    margin-top: 0;
  }
  .alice-stats__sub {
    display: none;
  }
}
</style>
